import * as TYPES from './MarketsTypes';
import {
  updateMarketVenueAvailability,
  clearMarketVenueAvailability,
} from '../../utils/updateMarkets';
import { SIGNOUT_USER_SUCCESS } from '../User/UserTypes';
import { formatAmpersand } from '../../utils/formatAmpersand';

const initialState = {
  list: [],
  market: null,
  cachedMarketId: null,
};

export default function marketReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case TYPES.MARKET_LIST_SUCCESS:
      return {
        ...state,
        list: payload,
      };
    case TYPES.GET_MARKET_SUCCESS:
      if (!payload) {
        return {
          ...state,
          market: null,
        };
      }
      const formattedVenues = payload.venues
        ? {
            ...payload.venues,
            items: (payload.venues?.items ?? []).map((venue) => ({
              ...venue,
              name: formatAmpersand(venue.name),
            })),
          }
        : null;
      return {
        ...state,
        market: {
          ...payload,
          venues: formattedVenues,
        },
      };
    case TYPES.CACHE_MARKET_ID:
      return {
        ...state,
        cachedMarketId: payload,
      };
    case TYPES.RESET_CACHED_MARKET_ID:
      return {
        ...state,
        cachedMarketId: initialState.cachedMarketId,
      };
    case TYPES.UPDATE_MARKET_AVAILABILITY:
      return {
        ...state,
        market: updateMarketVenueAvailability(state.market, payload),
      };
    case TYPES.CLEAR_MARKET_AVAILABILITY:
      return {
        ...state,
        market: clearMarketVenueAvailability(state.market),
      };
    case SIGNOUT_USER_SUCCESS:
      return initialState;
    default:
      return state;
  }
}
